module.exports = __webpack_public_path__ + "img/2.750a87c7.jpg";